<script setup>
</script>

<template>
    <h2 class="text-3xl font-bold text-center text-gray-900 mb-8">How it works</h2>
    <div class="grid gap-6 grid-cols-1 md:grid-cols-2 text-left max-w-4xl mx-auto">
        <div class="bg-white p-6 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-all relative">
            <div class="
                    absolute top-4 left-4 w-6 h-6 rounded-full 
                    bg-green-400 text-white
                    flex items-center justify-center text-sm font-extrabold">
                1
            </div>
            <div class="flex relative flex-col items-center text-center mb-4">
                    <div class="absolute top-2 right-0 transform rotate-[20deg] bg-green-100 text-green-600 text-xs font-medium py-1 px-3 rounded-full shadow-sm border border-green-200 z-10">
                        🎉 No app needed!
                    </div>
                    <svg class="w-48 aspect-video text-blue-600 my-4" viewBox="0 0 325 182" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="325" height="182" rx="6" fill="#D9D9D9"/>
                        <rect x="12" y="28" width="301" height="143" rx="6" fill="#B6B6B6"/>
                        <rect x="12" y="11" width="74" height="44" rx="6" fill="#B6B6B6"/>
                        <rect x="29" y="41" width="124" height="118" rx="6" fill="#C6C6C6"/>
                        <rect x="173" y="41" width="124" height="118" rx="6" fill="#C6C6C6"/>
                        <circle cx="306" cy="14" r="7" fill="#C6C6C6"/>
                        <circle cx="288" cy="14" r="7" fill="#C6C6C6"/>
                        <circle cx="270" cy="14" r="7" fill="#C6C6C6"/>
                        <path d="M95.625 65.75H75.375V72.5H68.625V92.75H75.375V72.5H95.625V65.75ZM95.625 92.75H75.375V99.5H95.625V92.75ZM95.625 72.5H102.375V92.75H95.625V72.5ZM58.5 113H65.25V106.25H105.75V113H65.25V126.5H105.75V113H112.5V133.25H58.5V113Z" fill="#A5A3A3"/>
                        <path d="M244.625 65.75H224.375V72.5H217.625V92.75H224.375V72.5H244.625V65.75ZM244.625 92.75H224.375V99.5H244.625V92.75ZM244.625 72.5H251.375V92.75H244.625V72.5ZM207.5 113H214.25V106.25H254.75V113H214.25V126.5H254.75V113H261.5V133.25H207.5V113Z" fill="#A5A3A3"/>
                    </svg>
                <h3 class="text-lg font-semibold text-gray-900">Join a Meeting<span class="underline-browser animate-pulse duration-6000 ml-1">in your browser</span></h3>
            </div>
            <p class="text-gray-600 text-center">
                Use a browser like Google Chrome, Brave or Edge to join a meeting.
            </p>
        </div>

        <div class="bg-white p-6 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-all relative">
            <div class="
                    absolute top-4 left-4 w-6 h-6 rounded-full 
                    bg-green-400 text-white
                    flex items-center justify-center text-sm font-extrabold">
                2
            </div>
            <div class="flex flex-col items-center text-center mb-4">
                <svg class="w-48 aspect-video text-blue-600 my-4"  viewBox="0 0 325 182" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="325" height="182" rx="6" fill="#D9D9D9"/>
                    <rect x="12" y="11" width="74" height="44" rx="6" fill="#C6C6C6"/>
                    <rect x="12" y="28" width="301" height="143" rx="6" fill="#B6B6B6"/>
                    <rect x="50" y="11" width="74" height="44" rx="6" fill="#B6B6B6"/>
                    <rect x="101" y="55" width="124" height="104" rx="6" fill="#C6C6C6"/>
                    <rect x="140" y="45" width="46" height="20" rx="10" fill="#D9D9D9"/>
                    <circle cx="306" cy="14" r="7" fill="#C6C6C6"/>
                    <circle cx="288" cy="14" r="7" fill="#C6C6C6"/>
                    <circle cx="270" cy="14" r="7" fill="#C6C6C6"/>
                </svg>
                <h3 class="text-lg font-semibold text-gray-900">Create a New Note</h3>
            </div>
            <p class="text-gray-600 text-center">
                Go to your dashboard on Jimmy the Cricket and create a new note.
            </p>
        </div>

        <div class="bg-white p-6 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-all relative">
            <div class="
                    absolute top-4 left-4 w-6 h-6 rounded-full 
                    bg-green-400 text-white
                    flex items-center justify-center text-sm font-extrabold">
                3
            </div>
            <div class="flex flex-col items-center text-center mb-4">
                <svg class="w-48 aspect-video text-blue-600 my-4"  viewBox="0 0 325 182" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="325" height="182" rx="6" fill="#D9D9D9"/>
                    <rect x="12" y="11" width="74" height="44" rx="6" fill="#C6C6C6"/>
                    <rect x="12" y="28" width="301" height="143" rx="6" fill="#B6B6B6"/>
                    <rect x="50" y="11" width="74" height="44" rx="6" fill="#B6B6B6"/>
                    <rect x="101" y="55" width="124" height="104" rx="6" fill="#C6C6C6"/>
                    <rect x="140" y="45" width="46" height="20" rx="10" fill="#D9D9D9"/>
                    <rect x="111" y="74" width="47" height="9" rx="2" fill="#B6B6B6"/>
                    <rect x="111" y="102" width="59" height="9" rx="2" fill="#B6B6B6"/>
                    <circle cx="306" cy="14" r="7" fill="#C6C6C6"/>
                    <circle cx="288" cy="14" r="7" fill="#C6C6C6"/>
                    <circle cx="270" cy="14" r="7" fill="#C6C6C6"/>
                </svg>
                <h3 class="text-lg font-semibold text-gray-900">
                    <span>Start Recording</span>
                    <span class="typing-wrapper"><span class="typing-text ml-1">and Typing</span></span>
                </h3>
            </div>
            <p class="text-gray-600 text-center">
                Share the tab where the meeting is taking place and start recording. You can take notes while recording.
            </p>
        </div>

        <div class="bg-white p-6 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-all relative">
            <div class="
                    absolute top-4 left-4 w-6 h-6 rounded-full 
                    bg-green-400 text-white
                    flex items-center justify-center text-sm font-extrabold">
                    4
            </div>
            <div class="flex flex-col items-center text-center mb-4">
                <svg class="w-48 aspect-video text-blue-600 my-4"  viewBox="0 0 325 182" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="325" height="182" rx="6" fill="#D9D9D9"/>
                    <rect x="12" y="11" width="74" height="44" rx="6" fill="#C6C6C6"/>
                    <rect x="12" y="28" width="301" height="143" rx="6" fill="#B6B6B6"/>
                    <rect x="50" y="11" width="74" height="44" rx="6" fill="#B6B6B6"/>
                    <rect x="101" y="55" width="124" height="104" rx="6" fill="#C6C6C6"/>
                    <rect x="140" y="45" width="46" height="20" rx="10" fill="#D9D9D9"/>
                    <rect x="111" y="74" width="47" height="9" rx="2" fill="#B6B6B6"/>
                    <rect x="111" y="88" width="57" height="9" rx="2" fill="#B6B6B6"/>
                    <rect x="111" y="116" width="68" height="9" rx="2" fill="#B6B6B6"/>
                    <rect x="111" y="130" width="52" height="9" rx="2" fill="#B6B6B6"/>
                    <rect x="111" y="102" width="40" height="9" rx="2" fill="#B6B6B6"/>
                    <circle cx="306" cy="14" r="7" fill="#C6C6C6"/>
                    <circle cx="288" cy="14" r="7" fill="#C6C6C6"/>
                    <circle cx="270" cy="14" r="7" fill="#C6C6C6"/>
                </svg>
                <h3 class="text-lg font-semibold text-gray-900">Stop Recording</h3>
            </div>
            <p class="text-gray-600 text-center">
                As soon as the meeting is over, stop recording. You can then click on the Star icon on top of the page to enrich your notes.
            </p>
        </div>
    </div>
</template>

<style scoped>
.typing-wrapper {
    display: inline-flex;
    align-items: center;
    width: 5.8em;
}

.typing-text {
    display: inline-block;
    overflow: hidden;
    border-right: 2px solid #666;
    white-space: nowrap;
    animation: typing 3s steps(10) infinite,
               blink-caret 0.75s step-end infinite;
    max-width: 0;
}

@keyframes typing {
    0%, 90%, 100% {
        max-width: 0;
    }
    30%, 60% {
        max-width: 5.8em;
    }
}

@keyframes blink-caret {
    from, to { border-color: transparent }
    50% { border-color: #666 }
}
</style>